<template>
  <div class="dinput-select">
    <select class="sl-input" v-model="fieldValue.valor">
      <option v-for="(v, key) in field.valores" :key="'val-' + key">{{v}}</option>
    </select>
  </div>
</template>

<script>
import Mixin from "@/reuse/input/dynamic/inputs/Mixin"

export default {
  name: "DSelect",
  mixins: [Mixin]
}
</script>
